export default "__VITE_ASSET__BaRNPASL__"